import React from 'react';
import { FiCheck, FiLogOut } from 'react-icons/fi';
import { useAuth } from '../auth/AuthContext';
import { useEntitlements } from '../entitlements/useEntitlements';
import AccountConnections from '../components/AccountConnections';
import '../pages/pages.css';
import './AccountPage.css';

const PLANS = [
  {
    tier: 'free' as const,
    name: 'Free',
    price: 'Ad-supported',
    features: ['Basic podcasts (short)', '2 voices', 'Save & sync documents', 'Ads shown'],
  },
  {
    tier: 'basic' as const,
    name: 'Basic',
    price: '$—/mo',
    features: ['Longer podcasts', 'Extra voices & tone', 'Long read-aloud', 'No ads'],
  },
  {
    tier: 'pro' as const,
    name: 'Pro',
    price: '$—/mo',
    features: ['Everything in Basic', 'Audiobooks', 'Highest quality', 'No ads'],
  },
];

export default function AccountPage() {
  const { email, userId, logout } = useAuth();
  const { tier, loading } = useEntitlements();

  return (
    <div className="page">
      <div className="page__header">
        <div>
          <h1 className="page__title">Account</h1>
          <p className="page__subtitle">Manage your plan and sign-in.</p>
        </div>
        <button className="btn btn--ghost btn--sm" onClick={logout}>
          <FiLogOut /> Sign out
        </button>
      </div>

      <div className="card acct-identity">
        <div className="acct-avatar">{(email || 'U').charAt(0).toUpperCase()}</div>
        <div>
          <div className="acct-email">{email || `User #${userId ?? ''}`}</div>
          <div className="muted">
            Current plan:{' '}
            <span className="pill">{loading ? '…' : tier === 'free' ? 'Free' : tier === 'basic' ? 'Basic' : 'Pro'}</span>
          </div>
        </div>
      </div>

      <AccountConnections />
      <div className="acct-plans">
        {PLANS.map((plan) => {
          const current = plan.tier === tier;
          return (
            <div key={plan.tier} className={`acct-plan${current ? ' acct-plan--current' : ''}`}>
              <div className="acct-plan__name">{plan.name}</div>
              <div className="acct-plan__price">{plan.price}</div>
              <ul className="acct-plan__features">
                {plan.features.map((f) => (
                  <li key={f}>
                    <FiCheck /> {f}
                  </li>
                ))}
              </ul>
              {current ? (
                <button className="btn btn--ghost btn--block" disabled>
                  Current plan
                </button>
              ) : plan.tier === 'free' ? (
                <span />
              ) : (
                <button className="btn btn--primary btn--block" disabled title="Checkout pending PaymentsService update">
                  Upgrade
                </button>
              )}
            </div>
          );
        })}
      </div>

      <p className="muted acct-note">
        Subscription checkout and one-off pay-per-item purchases connect to Stripe via PaymentsService.
        Those endpoints are pending backend updates.
      </p>
    </div>
  );
}
